"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchListRegistrations = exports.FetchListRegistrations = exports.FetchListRegistrationsActionTypes = exports.ContentMembershipActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var ContentMembershipActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_LIST_REGISTRATIONS: null,
  FETCH_LIST_REGISTRATIONS: null
}, 'shared');
exports.ContentMembershipActionTypes = ContentMembershipActionTypes;
var FetchListRegistrationsActionTypes = (0, _actions.createRequestTypes)(ContentMembershipActionTypes.FETCH_LIST_REGISTRATIONS);
exports.FetchListRegistrationsActionTypes = FetchListRegistrationsActionTypes;
var FetchListRegistrations = (0, _actions.createRequestActions)(FetchListRegistrationsActionTypes);
exports.FetchListRegistrations = FetchListRegistrations;
var fetchListRegistrations = (0, _fluxActions.createAction)(ContentMembershipActionTypes.LOAD_LIST_REGISTRATIONS, function (listId) {
  return listId;
});
exports.fetchListRegistrations = fetchListRegistrations;